export function generateId() {
  // "ddmmyyyyhhmmssms{random number}"
  let date = new Date();
  let id = `${date.getDate()}${date.getMonth()}${date.getFullYear()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}${date.getMilliseconds()}${Math.floor(
    Math.random() * 100
  )}`;
  return id;
}
